import React from 'react';
import { Info } from 'lucide-react';
import { REBUILD_NOTICE_TITLE, REBUILD_NOTICE_BODY } from '../lyphline';

// Amber disclosure banner clarifying rebuild-with-aftermarket-parts (non OEM).
export const RebuildNotice = ({ className = '' }) => (
  <div className={`flex items-start gap-3 bg-amber-50 border border-amber-300 rounded-xl p-4 ${className}`} data-testid="rebuild-notice">
    <Info className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
    <p className="text-sm text-amber-900">
      <strong>{REBUILD_NOTICE_TITLE}</strong> {REBUILD_NOTICE_BODY}
    </p>
  </div>
);

export default RebuildNotice;
